module.exports = __webpack_public_path__ + "img/35400.fa997ce6.jpg";